"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickEmAbilityHandler = exports.StickEmActorAbilityFactory = exports.StickEmAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class StickEmAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.StickEm;
        this.__typeName = "StickEm";
    }
}
exports.StickEmAbilityArgs = StickEmAbilityArgs;
let StickEmActorAbilityFactory = class StickEmActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("StickEm", "OneEnemies", 0);
    }
};
StickEmActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("StickEm")
], StickEmActorAbilityFactory);
exports.StickEmActorAbilityFactory = StickEmActorAbilityFactory;
let StickEmAbilityHandler = class StickEmAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 50)
            ]
        });
    }
};
StickEmAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.StickEm)
], StickEmAbilityHandler);
exports.StickEmAbilityHandler = StickEmAbilityHandler;
